module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-cream-003-1200x2490.050f6cbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-cream-003-1200x2490.jpg
// module id = 1092
// module chunks = 37